import {combineReducers, configureStore} from "@reduxjs/toolkit";
import logger from 'redux-logger'
import thunkMiddleware from 'redux-thunk'
import instrumentsReducer from "./reducers/instruments";
import tagsReducer from "./reducers/tags";
import authenticatedReducer from "./reducers/authenticated";
import messageReducer from "./reducers/message";
import selectedFiltersReducer from "./reducers/selectedFilters";

// here we will be adding reducers
const reducer = combineReducers({
  instruments: instrumentsReducer,
  tags: tagsReducer,
  isAuthenticated: authenticatedReducer,
  message: messageReducer,
  selectedFilters: selectedFiltersReducer,
})

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([logger, thunkMiddleware]),
  devTools: process.env.NODE_ENV !== 'production',
})

export type AppDispatch = typeof store.dispatch

export default store;